import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Button, Card, Input, Modal, Table} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {
  updateProviderInvoiceStep,
} = Actions;

const EtaManagementInvoiceDateModal = ({showFechaFacturaModal, setShowFechaFacturaModal, data}) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [newComment, setNewComment] = useState('');
  const {filters} = useSelector((state) => state.dealerOrdersEtaManagement);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showFechaFacturaModal) {
      setNewComment(data.order_observation);
    }
  }, [showFechaFacturaModal]);
  
  const handleInvoiceOrderNewDate = (val) => {
    if (selectedDate !== val) {
      setSelectedDate(val);
    }
  };

  const handleNewComment = (val) => {
    setNewComment(val);
  };

  const handleEtaUpdate = () => {
    const payload = {
      'comment': newComment,
      'processId': '03',
      'tentativeDate': selectedDate,
    };
    dispatch(updateProviderInvoiceStep(data.sequence, payload, filters, setShowFechaFacturaModal));
  };

  return (
    <Modal size='large' closeIcon open={showFechaFacturaModal}
      onClose={() => setShowFechaFacturaModal(null)}>
      <Modal.Header><h2>Tracking</h2></Modal.Header>
      <Modal.Content>
        <div className='dealer-orders-tracking-schedule'>
          <Card raised fluid className='tracking-body'>
            <Table className='full-table'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width='2'>Proceso</Table.HeaderCell>
                  <Table.HeaderCell width='1'>Fecha Actual</Table.HeaderCell>
                  <Table.HeaderCell width='2'>Nueva Fecha</Table.HeaderCell>
                  <Table.HeaderCell width='4'>Observaciones</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>FACTURACIÓN PROVEEDOR</Table.Cell>
                  <Table.Cell>{data.tde_process_invoice_date &&
                    moment(data.tde_process_invoice_date).format(reverseShortDate)}</Table.Cell>
                  <Table.Cell>
                    <DatePicker
                      customInput={
                        <Input icon='calendar' size='small' />
                      }
                      onChange={(value) => handleInvoiceOrderNewDate(value)}
                      selected={selectedDate ?
                        moment(selectedDate, reverseShortDate).toDate() : ''}
                      placeholderText="dd/mm/aaaa"
                      className="kanban-logistics-datepicker"
                      dateFormat={'dd/MM/yyyy'}
                      locale='es'
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <Input fluid
                      value={newComment}
                      onChange={(e, {value}) => handleNewComment(value)} />
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Card>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button color='green' onClick={() => handleEtaUpdate(null)}>Actualizar</Button>
        <Button onClick={() => setShowFechaFacturaModal(null)}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EtaManagementInvoiceDateModal;
